var path = 'src/app/components/customer/landing-page/customer-landing-page.template.html';
var html = "<customer-breadcrumbs></customer-breadcrumbs>\n<div id='customer-landing-page' class=\"box\"></div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;